import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';

import {
  FormGroup,
  Card,
  CardHeader,
  Form,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import TaxServiceService from './TaxServiceService';
import TaxServiceCategoryService from '../category/TaxServiceCategoryService';

export default class AddTaxService extends Component {
  state = {
    name: '',
    description: '',
    category_id: '',
    status: true,
    categories: [],
    errors: {},
    loading: false,
  };

  componentDidMount() {
    TaxServiceCategoryService.listCategories(1, 100)
      .then((res) => this.setState({ categories: res.data.data }))
      .catch(() => {});
  }

  onChangeInput = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { name, description, category_id, status } = this.state;

    if (!name) {
      this.setState({ errors: { name: 'Service name is required' } });
      return;
    }
    if (!category_id) {
      this.setState({ errors: { category_id: 'Category is required' } });
      return;
    }

    this.setState({ loading: true, errors: {} });
    TaxServiceService.createService({ name, description, category_id, status })
      .then(() => {
        NotificationManager.success('Tax service created!', 'Success!', 2000);
        this.props.history.push('/admin/tax-services');
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || 'Failed to create service.';
        NotificationManager.error(msg, 'Error', 3000);
        this.setState({ loading: false });
      });
  };

  render() {
    const { name, description, category_id, status, categories, errors, loading } = this.state;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Create Tax Service</h3>
                </CardHeader>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="name">Service Name</Label>
                      <Input
                        type="text"
                        name="name"
                        id="name"
                        value={name}
                        onChange={this.onChangeInput}
                        required
                        minLength={3}
                        maxLength={350}
                      />
                      {errors.name && <small className="text-danger">{errors.name}</small>}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="category_id">Category</Label>
                      <Input
                        type="select"
                        name="category_id"
                        id="category_id"
                        value={category_id}
                        onChange={this.onChangeInput}
                        required
                      >
                        <option value="">-- Select Category --</option>
                        {categories.map((cat) => (
                          <option key={cat._id} value={cat._id}>
                            {cat.category}
                          </option>
                        ))}
                      </Input>
                      {errors.category_id && (
                        <small className="text-danger">{errors.category_id}</small>
                      )}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label for="description">Description</Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="description"
                        value={description}
                        onChange={this.onChangeInput}
                        maxLength={1000}
                        rows={4}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="status"
                          checked={status}
                          onChange={this.onChangeInput}
                        />{' '}
                        Active
                      </Label>
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={12}>
                      <Button type="submit" className="btn btn-primary mr-2" disabled={loading}>
                        {loading ? 'Saving...' : 'Submit'}
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={() => this.props.history.push('/admin/tax-services')}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </FormGroup>
                </Form>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
